module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-transcript/ipp-transcript.component.html
// module id = 5XV9
// module chunks = 1